"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _view = require("../view");

var _reactFela = require("react-fela");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Text = function Text(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'body' : _ref$variant,
      subVariant = _ref.subVariant,
      extend = _ref.extend,
      children = _ref.children,
      diffuse = _ref.diffuse,
      color = _ref.color,
      as = _ref.as,
      bold = _ref.bold,
      props = _objectWithoutProperties(_ref, ["variant", "subVariant", "extend", "children", "diffuse", "color", "as", "bold"]);

  var _useFela = (0, _reactFela.useFela)(),
      theme = _useFela.theme;

  var font = theme.font;
  var variants = {
    small: {
      fontSize: 10,
      fontWeight: 'normal',
      fontFamily: font,
      letterSpacing: 1
    },
    body: {
      fontSize: 12,
      fontWeight: 'normal',
      fontFamily: font,
      letterSpacing: 1
    },
    medium: {
      fontSize: 14,
      fontWeight: 'normal',
      fontFamily: font,
      letterSpacing: 1
    },
    large: {
      fontSize: 22,
      fontWeight: 'normal',
      fontFamily: font,
      letterSpacing: 1
    },
    title: {
      fontSize: 32,
      fontWeight: 'normal',
      fontFamily: font,
      letterSpacing: 1
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_view.View, _extends({
    as: as ? as : variant === 'title' ? 'h1' : 'p',
    extend: [textCSS({
      variants: variants,
      variant: variants[variant],
      subVariant: subVariant,
      bold: bold,
      diffuse: diffuse,
      color: color
    }), extend]
  }, props), children);
};

exports.Text = Text;
Text.propTypes = {
  variant: _propTypes["default"].oneOf(['small', 'body', 'medium', 'large', 'title']),
  subVariant: _propTypes["default"].oneOf(['inline']),
  extend: _propTypes["default"].object,
  children: _propTypes["default"].element.isRequired,
  diffuse: _propTypes["default"].bool,
  color: _propTypes["default"].string,
  as: _propTypes["default"].string
};

var textCSS = function textCSS(_ref2) {
  var variant = _ref2.variant,
      subVariant = _ref2.subVariant,
      diffuse = _ref2.diffuse,
      bold = _ref2.bold,
      color = _ref2.color;
  return function (_ref3) {
    var colors = _ref3.theme.colors;
    return _objectSpread(_objectSpread(_objectSpread({}, variant), {}, {
      color: color && colors[color] ? colors[color] : diffuse ? colors.bodySecondary : colors.body
    }, bold && {
      fontWeight: 'bold'
    }), {}, {
      extend: [{
        condition: subVariant === 'inline',
        style: {
          display: 'inline-block'
        }
      }]
    });
  };
};